import PosthogPlugin from './posthog';
import ClarityPlugin from './clarity';

const provider = process.env.VUE_APP_ANALYTICS_PROVIDER || 'posthog'; // default to posthog

export default {
    install(Vue: any) {
        if (provider === 'clarity') {
            Vue.use(ClarityPlugin);
            console.log('Analytics provider: Clarity');
        } else {
            Vue.use(PosthogPlugin);
            console.log('Analytics provider: PostHog');
        }
        
        // Add provider to be accessible globally
        Vue.prototype.$analyticsProvider = provider;
    }
} 